import { render, staticRenderFns } from "./knowledgeAddS.vue?vue&type=template&id=386beeab&scoped=true&"
import script from "./knowledgeAddS.vue?vue&type=script&lang=js&"
export * from "./knowledgeAddS.vue?vue&type=script&lang=js&"
import style0 from "./knowledgeAddS.vue?vue&type=style&index=0&id=386beeab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386beeab",
  null
  
)

export default component.exports